
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import dialog from '@/components/dialog.vue';
  import uploadImg from "@/components/upload-img.vue"
	import Message from '@/components/message.vue';
  import {
    activitycouponsendMemberCouponImportRecord,
    activitycouponsendMemberCouponImport
  } from "@/api/finance"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog':dialog,
      uploadImg,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private tablelist:any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1
    private upShow = false
    private uploading = false
    private filePath:any = []
    private fileName = ''
    private tipshow = false


    private mounted () {
      this.gettablelist()
    }



    private down(row){
      let url = location.origin + '/pc/activitycoupon/sendMemberCouponImportResultExport?RecordId='+row.Id+'&IsExport=true'
      window.open(url)
    }
    private closetips(){
      this.importCancel()
      this.tipshow = false
      this.gettablelist()
    }
    private async confirmImport(){
      if(!this.filePath||!this.filePath.length){
        this.$message.error('请上传文件')
        return
      }
      try{
        this.uploading = true
        let res:any = await activitycouponsendMemberCouponImport({
          ExcelFilePath:this.filePath[0],
          ExcelFileName:this.fileName,
          ActivityCouponId:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.tipshow = true
        }
      }finally{
        this.uploading = false
      }
    }
    private importCancel(){
      this.fileName = ''
      this.filePath = []
      this.upShow = false
    }
    private uploadSuc(file,name){
      this.filePath = file
      this.fileName = name
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await activitycouponsendMemberCouponImportRecord({
          ActivityCouponId:this.$route.query.Id,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
